import IndexedDatabase from "./indexedDb";
import bootbox from "bootbox";
import request from "./request";

var EventSelect = (function (bootbox) {
  const getHeader = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  var previousEvent = $("#previousEventTmp");

  function showAssignSeats() {
    if ($("#AssignPlayersToTables").is(":checked") == true) {
      $("#divAssignSeats").show();
    } else {
      $("#divAssignSeats").hide();
    }
  }

  function resetRegionsDropdown(regions) {
    if (regions != undefined) {
      $("#ddlRegions").empty();
      var option = $("<option />");
      option.attr("value", "0").text("Select");
      $("#ddlRegions").append(option);
      $.each(regions, function (_index, element) {
        option = $("<option />");
        option.attr("value", element.regionId).text(element.regionName);
        $("#ddlRegions").append(option);
      });
    }
  }

  function resetVenuesDropdown(venues) {
    if (venues != undefined) {
      $("#ddlVenues").empty();
      var option = $("<option />");
      option.attr("value", "0").text("Select");
      $("#ddlVenues").append(option);
      $.each(venues, function (_index, element) {
        option = $("<option />");
        option.attr("value", element.venueId).text(element.venueName);
        $("#ddlVenues").append(option);
      });
    }
  }

  function resetEventsDropdown(events) {
    if (events != undefined) {
      $("#ddlEvents").empty();
      var option = $("<option />");
      option.attr("value", "0").text("Select");
      $("#ddlEvents").append(option);
      $.each(events, function (_index, element) {
        option = $("<option />");
        option.attr("value", element.eventId).text(element.eventName);
        $("#ddlEvents").append(option);
      });
    }
  }

  function togglePreviousEventFormSubmitButton() {
    const eventId = parseInt($("#formPreviousEvent #EventId").val(), 10);
    const valid = !isNaN(eventId) && eventId > 0;
    $("#formPreviousEvent")
      .closest("div.modal")
      .find("button.btn-submit")
      .toggleClass("disabled", !valid);
  }

  function registerEventHandlers() {
    $("#AssignPlayersToTables").change(function () {
      showAssignSeats();
    });

    $("#ddlStates").change(async (event) => {
      try {
        const stateId = $(event.target).val();
        const parsedData = await request(
          `/api/event/filterbystate/${stateId}`,
          getHeader
        );

        var { regions, venues, events } = parsedData;
        resetRegionsDropdown(regions);
        resetVenuesDropdown(venues);
        resetEventsDropdown(events);
      } catch (error) {
        console.error("Error fetching state data:", error);
      }
    });

    $("#ddlRegions").change(async (event) => {
      try {
        const stateId = $("#ddlStates").val();
        const regionId = $(event.target).val();
        const parsedData = await request(
          `/api/event/filterByStateRegion/${stateId}/${regionId}`,
          getHeader
        );
        var { venues, events } = parsedData;
        resetVenuesDropdown(venues);
        resetEventsDropdown(events);
      } catch (error) {
        console.error("Error fetching region data:", error);
      }
    });

    $("#ddlVenues").change(async (event) => {
      try {
        const stateId = $("#ddlStates").val();
        const regionId = $("#ddlRegions").val();
        const venueId = $(event.target).val();
        const parsedData = await request(
          `/api/event/filterByStateRegionVenue/${stateId}/${regionId}/${venueId}`,
          getHeader
        );
        var { events } = parsedData;
        resetEventsDropdown(events);
      } catch (error) {
        console.error("Error fetching venue data:", error);
      }
    });

    $("#ddlMajorEvents").change(async (event) => {
      try {
        const majorEventId = $(event.target).val();
        const parsedData = await request(
          `/api/event/filterByMajorEvent/${majorEventId}`,
          getHeader
        );

        var { events } = parsedData;
        resetEventsDropdown(events);
      } catch (error) {
        console.error("Error fetching major event data:", error);
      }
    });

    $("#IsSetupTables").click(function () {
      if (this.checked) {
        $('#Tables, label[for="Tables"]').hide();
        $("#lblOr").hide();
        $('#PlayersPerTable, label[for="PlayersPerTable"]').hide();
        $('#tableSetupNote, label[for="tableSetupNote"]').hide();
      } else {
        $('#Tables, label[for="Tables"]').show();
        $("#lblOr").show();
        $('#PlayersPerTable, label[for="PlayersPerTable"]').show();
        $('#tableSetupNote, label[for="tableSetupNote"]').show();
      }
    });

    $("input[name=previousEvents]").change((event) => {
      const eventId = $(event.target).val();
      const stateId = $(event.target).data("state-id");
      const venueId = $(event.target).data("venue-id");
      const venueName = $(event.target).data("venue-name");
      const assignTable = $(event.target).data("assign-table");
      const assignSeats = $(event.target).data("assign-seats");
      $("#formPreviousEvent #StateId").val(stateId);
      $("#formPreviousEvent #EventId").val(eventId);
      $("#formPreviousEvent #VenueId").val(venueId);
      $("#formPreviousEvent #VenueName").val(venueName);
      $("#formPreviousEvent #AssignPlayersToTable").val(assignTable);
      $("#formPreviousEvent #AssignSeats").val(assignSeats);
      togglePreviousEventFormSubmitButton();
    });
  }

  function init() {
    $(document).ready(function () {
      /*
       * check if previous event form button should be enabled
       */
      togglePreviousEventFormSubmitButton();
      localStorage.clear();
      showAssignSeats();
      $.validator.setDefaults({ ignore: [] });
      registerEventHandlers();
    });
  }
  return {
    displayPreviousEvent: function (title) {
      bootbox.dialog({
        message: title
          ? "<p>" + title + "</p>" + previousEvent.html()
          : previousEvent.html(),
        onEscape: false,
        closeButton: false,
        buttons: {
          cancel: {
            label: "No",
            className: "btn-default",
          },
          ok: {
            label: "Yes",
            className: "btn-primary disabled btn-submit",
            callback: function () {
              $("#formPreviousEvent").submit();
            },
          },
        },
      });
    },
    hasPreviousEvent: previousEvent.length > 0,
    init,
  };
})(bootbox, IndexedDatabase);

export default EventSelect;
